import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeThirdpartyUsefore extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  usefor_id: "",
                  usefor_name: "",
                  usefor_percent: "",
                  selectedCarMode: "",
                  optionCarMode: [],

                  orderBy: "usefor_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newThirdpartyUsefore: true,
            }
      }

      handleCarMode = (selectedCarMode) => {
            this.setState({ selectedCarMode: selectedCarMode }, () => {
                  this.filterFieldCompany()
            })
      }

      handleChangeThirdpartyUseforeName = (event) => {
            this.setState({ usefor_name: event.target.value })
      }

      handleChangeThirdpartyUseforeId = (event) => {
            this.setState({ usefor_id: event })
      }

      handleusefor_percent = (event) => {
            this.setState({ usefor_percent: event })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        usefor_id: row2.usefor_id,
                        usefor_name: row2.usefor_name,
                        usefor_percent: row2.usefor_percent,
                        selectedCarMode: { value: row2.usefor_carmode_id, label: row2.carmode_name },

                        newThirdpartyUsefore: false,
                  },
                  () => {}
            )
      }

      newThirdpartyUsefore = (event) => {
            this.setState({
                  usefor_id: "",
                  usefor_name: "",
                  usefor_percent: "",
                  newThirdpartyUsefore: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getThirdpartyUsefore()
                                    self.getoptionCarMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionCarMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].carmode_id, label: arr.data[k].carmode_name })
                              }
                              self.setState({ optionCarMode: Company, selectedCarMode: Company[0] }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carmode")
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getThirdpartyUsefore() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_usefor")

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewThirdpartyUsefore = () => {
            const { usefor_id, usefor_name, selectedCarMode, usefor_percent } = this.state
            if (usefor_percent != "" && usefor_name != "" && usefor_id != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getThirdpartyUsefore()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_usefor")
                  fd.append("thirdparty_usefor_id", usefor_id)
                  fd.append("thirdparty_usefor_desc", usefor_name)
                  fd.append("usefor_percent", usefor_percent)
                  fd.append("usefor_carmode_id", selectedCarMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مورد استفاده را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      deleteThirdpartyUsefore = () => {
            const { usefor_id } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.newThirdpartyUsefore()
                              self.getThirdpartyUsefore()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_usefor")
            fd.append("usefor_id", usefor_id)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeThirdpartyUsefore = () => {
            const { usefor_id, usefor_name, selectedCarMode, usefor_percent } = this.state
            if (usefor_percent != "" && usefor_name != "" && usefor_id != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getThirdpartyUsefore()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_usefor")
                  fd.append("thirdparty_usefor_id", usefor_id)
                  fd.append("thirdparty_usefor_desc", usefor_name)
                  fd.append("thirdparty_usefor_percent", usefor_percent)
                  fd.append("usefor_carmode_id", selectedCarMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مورد استفاده را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterFieldCompany = () => {
            const { selectedCarMode, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (temparray[i].usefor_carmode_id === selectedCarMode.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  optionCarMode,
                  selectedCarMode,
                  usefor_percent,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newThirdpartyUsefore,
                  usefor_id,
                  usefor_name,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}></Grid>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع اتوموبیل </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع اتوموبیل"}
                                                                              value={selectedCarMode}
                                                                              onChange={this.handleCarMode}
                                                                              options={optionCarMode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="ای دی مورد استفاده"
                                                                        handleInputt={this.handleChangeThirdpartyUseforeId}
                                                                        value={usefor_id}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="مورد استفاده"
                                                                        handleInputt={this.handleChangeThirdpartyUseforeName}
                                                                        value={usefor_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد اضافه نرخ "
                                                                        handleInputt={this.handleusefor_percent}
                                                                        value={usefor_percent}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newThirdpartyUsefore ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.saveNewThirdpartyUsefore()
                                                                              }}
                                                                        >
                                                                              {"ثبت مورد استفاده جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newThirdpartyUsefore}
                                                                              >
                                                                                    {"مورد استفاده جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.changeThirdpartyUsefore()
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deleteThirdpartyUsefore()
                                                                                    }}
                                                                              >
                                                                                    {"حذف"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"usefor_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "usefor_id" ? order : false}
                                                                              >
                                                                                    {"آیدی مورد استفاده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "usefor_id"}
                                                                                          direction={
                                                                                                orderBy === "usefor_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("usefor_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"usefor_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مورد استفاده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "usefor_name"}
                                                                                          direction={
                                                                                                orderBy === "usefor_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("usefor_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"usefor_percent"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد اضافه نرخ"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "usefor_percent"}
                                                                                          direction={
                                                                                                orderBy === "usefor_percent"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("usefor_percent")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>

                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["usefor_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"usefor_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["usefor_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"usefor_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["usefor_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"usefor_percent"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["usefor_percent"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeThirdpartyUsefore)
